import commonJsModule from "publishimo-webpack-plugin"

export default commonJsModule.default